import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_RjeMYoqrwdCu: {
	id: 'prd_RjeMY2DEV2oqrwdCu'
	ident: 'prd_RjeMYoqrwdCu'
	sku: 'simple_premium_12w_15_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_itbIA2DEV2cZ9irNw'
			amount: 79
			amount_usd: 15.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 15.99
			discount: 63.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_y902i2DEV24rcBAAA'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_RjeMYoqrwdCu, SubscriptionProduct>
const prd_RjeMYoqrwdCu = { ident: 'prd_RjeMYoqrwdCu' } as typeof _prd_RjeMYoqrwdCu

export default prd_RjeMYoqrwdCu
